<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';

export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center h-full px-6 py-12 text-center max-w-sm mx-auto"
  >
    <div class="relative mb-5 flex items-center justify-center">
      <div
        class="size-16 rounded-2xl bg-[#125c4f]/10 dark:bg-[#125c4f]/20 border border-[#125c4f]/20 flex items-center justify-center shadow-xs"
      >
        <svg
          class="size-8 text-[#125c4f] dark:text-[#2dd4bf]"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
          />
          <path d="M8 10h.01" />
          <path d="M12 10h.01" />
          <path d="M16 10h.01" />
        </svg>
      </div>
      <div
        class="absolute -bottom-1 -right-1 size-5 rounded-full bg-[#125c4f] text-white flex items-center justify-center border-2 border-white dark:border-n-surface-1 shadow-xs"
      >
        <span class="i-lucide-check size-3" />
      </div>
    </div>
    <span
      class="text-base text-n-slate-12 font-semibold tracking-tight text-center mb-1"
    >
      {{ message }}
    </span>
    <p class="text-xs text-n-slate-10 max-w-xs mb-4">
      {{ $t('CONVERSATION.EMPTY_STATE.HINT') }}
    </p>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
